import { Link } from "@tanstack/react-router";
import { REGIONAL_HUBS, TRADE_GUIDES } from "@/lib/regionalHubs";

/** Cross-link block promoting regional hubs and trade lead guides. */
export function RegionalHubLinks({ excludePath }: { excludePath?: string }) {
  const guides = TRADE_GUIDES.filter((g) => g.slug !== excludePath);
  return (
    <section aria-label="Colorado contractor marketing hubs" className="not-prose mt-12 grid gap-6 md:grid-cols-2">
      {REGIONAL_HUBS.filter((h) => h.path !== excludePath).map((h) => (
        <div key={h.slug} className="rounded-2xl border border-border bg-card p-6 shadow-card">
          <p className="text-xs font-bold uppercase tracking-wider text-brand-gold-ink">{h.shortName}</p>
          <Link to={h.path} className="mt-1 block text-lg font-bold text-foreground hover:underline">
            {h.name}
          </Link>
          <p className="mt-2 text-sm text-muted-foreground">Serving {h.coverage.join(", ")}.</p>
        </div>
      ))}
      <div className="rounded-2xl border border-border bg-card p-6 shadow-card">
        <p className="text-xs font-bold uppercase tracking-wider text-brand-gold-ink">Contractor lead guides</p>
        <ul className="mt-2 space-y-1.5 text-sm">
          {guides.map((g) => (
            <li key={g.slug}>
              <Link to={g.slug} className="font-semibold text-foreground hover:underline">
                {g.trade} leads in Colorado
              </Link>
            </li>
          ))}
          <li>
            <Link to="/web-design-castle-rock-colorado" className="font-semibold text-foreground hover:underline">
              Castle Rock web design company
            </Link>
          </li>
          <li><Link to="/concrete-web-design-castle-rock" className="font-semibold text-foreground hover:underline">Concrete web design in Castle Rock</Link></li>
          <li><Link to="/fence-deck-web-design-castle-rock" className="font-semibold text-foreground hover:underline">Fence &amp; deck web design in Castle Rock</Link></li>
          <li><Link to="/colorado-springs-office-woodmen-rd" className="font-semibold text-foreground hover:underline">Our Woodmen Rd office &amp; Google profile</Link></li>
          <li><Link to="/colorado-web-design" className="font-semibold text-foreground hover:underline">Colorado web design company</Link></li>
          <li><Link to="/colorado-seo" className="font-semibold text-foreground hover:underline">Colorado SEO services</Link></li>
        </ul>
      </div>
    </section>
  );
}
